import axios from 'axios';
import qs from 'qs'
import store from '@/store/index.js'
 // const baseURL= 'https://www.schoolassignment.cn:130/api/';

export default {
	request(config) {
		
		const instance = axios.create({
			baseURL:store.state.baseURL,
			timeout: 5000
		});
		//请求开始拦截
		config.data.userCode = store.state.user.UserCode;
		config.data = qs.stringify(config.data);
		instance.interceptors.request.use(config => {
			//在这里可以检查请求信息，如果不符合要求则拦截请求
			return config;
		}, err => {});
		instance.interceptors.response.use(res => {
			return res.data;
		}, err => {
			console.log(err);
		});
		return instance(config);
	},
	upLoadFile(config) {
		const instance = axios.create({
			baseURL:store.state.baseURL,
			timeout: 5000,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
		//请求开始拦截
		//config.data.userCode = store.state.user.UserCode;
		//config.data = qs.stringify(config.data);
		instance.interceptors.request.use(config => {
			//在这里可以检查请求信息，如果不符合要求则拦截请求
			return config;
		}, err => {});
		instance.interceptors.response.use(res => {
			return res.data;
		}, err => {
			console.log(err);
		});
		return instance(config);

	},
	get(config) {
		const instance = axios.create({	
			timeout: 5000
		});
		//请求开始拦截
		//config.data.userCode = store.state.user.UserCode;
		//config.data = qs.stringify(config.data);
		instance.interceptors.request.use(config => {
			return config;
		}, err => {});
		instance.interceptors.response.use(res => {
			return res.data;
		}, err => {
			console.log(err);
		});
		return instance(config);
	
	}
}
